import * as Yup from "yup";
import React from "react";
import { FilePreview, FormItemProps } from "@/components/Form/types";

import ImageComponent from "@/components/UiElements/ImageComponent";
import getPrices from "@/services/ProductService/getPrices";
import {snapshot} from "valtio";
import store from "@/store";
import getAllProducts from "@/services/ProductService/getAllProducts";
import ListLabelDescription from "@/components/UiElements/ListLabelDescription";



const Items: Array<FormItemProps> = [

    {
        name: 'name',
        label: 'Name',
        placeholder: 'Enter product name',
        type: 'Text',
        defaultValue: null,
        validation: Yup.string().required('Name is required'),
        classNames: {container: 'col-span-9 '},
        autoFocus: true,
    },
    {
        name: 'quantity',
        label: 'Quantity',
        placeholder: '0',
        type: 'Number',
        itemOptions: {
            min: 1,
            max: 10
        },
        defaultValue: 1,
        validation: Yup.string().required('Quantity is required'),
        classNames: {container: 'col-span-3 '},
    },
    {
        name: 'pricing_id',
        label: 'Select Pricing',
        placeholder: 'Select Pricing',
        type: 'Select',
        itemOptions: {
            portal: document.querySelector('body'),
            fetch: async () => {
                const prices = await getPrices() || [];
                return [
                    ...prices.map((price: any) => ({
                        label:
                            <span className={"capitalize flex flex-col"}>
                                {price.name.replace(/_/g, ' ').replace(/-/g, ' ')}
                                <span className={"flex flex-row gap-md text-text-md text-gray-400"} >
                                    <span >Price: {price.price}</span>
                                    <span >Model: {price.price_model}</span>
                                    <span >Discount: {price.discount_model}, {price.discount_type}</span>
                                </span>
                            </span>,
                        value: price.id,
                        searchLabel: price.name.replace(/_/g, ' ').replace(/-/g, ' '),
                        selectLabel: <span className={"capitalize flex flex-col"}>{price.name.replace(/_/g, ' ').replace(/-/g, ' ')}</span>,
                    }))
                    ]
            }
        },
        defaultValue: null,
        classNames: {container: 'col-span-12 '},
        autoFocus: true,
    },
    {
        name: '2d_image_url',
        label: 'Product thumbnail',
        type: 'File',
        classNames: {
            container: 'col-span-12 break-line',
            content: '!h-[165px]'
        },
        placeholder: "Drag and drop your image here",
        itemOptions: {
            filePreview: (file: FilePreview) => (
                file.string ? <ImageComponent
                    src={file.string}
                    style={{ height: "120px", width: "120px" }}
                    className="w-[120px] h-[120px]"
                /> : null
            ),
            acceptFormat: '.png, .jpg, .jpeg',
        },
        validation:Yup.object().typeError('Thumbnail is required')
    },
]

export default Items;